<template>
  <div class="shadow">
    <h2 class="p-2">Peta Sebaran Data dan Informasi Pengendalian KKPRL ({{ tahun }})</h2>
    <div class="position-relative">
      <l-map
        style="height: 80vh; background: transparent"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        @ready="onMapReady"
      >
        <l-geo-json v-if="geojson" :geojson="geojson" :options="options" />
      </l-map>
      <div v-if="activeFeature" class="data-container">
        <h5 class="fw-semibold">{{ activeFeature.PROVINSI }}</h5>
        <div v-if="loadingLaporan" class="text-center my-4">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <table v-else>
          <tbody>
            <tr v-for="(v, k) in dataLaporan">
              <td>{{ k.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) }}</td>
              <td style="width: 100%">: {{ v }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LGeoJson } from 'vue2-leaflet'
import provinsi from './provinsi.json'
import axios from 'axios'
import L from 'leaflet'
import 'leaflet-easybutton'
import 'leaflet-easybutton/src/easy-button.css'

export default {
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
  },
  props: ['tahun', 'bulan'],
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 5,
      center: [-1.897, 118.5303],
      mapOptions: {
        zoomControl: true,
        scrollWheelZoom: false,
      },
      geojson: null,
      activeFeature: null,
      activeLayer: null,
      dataLaporan: {
        jumlah_laporan_tahunan: 0,
        laporan_tahunan_selesai: 0,
        laporan_belum_diverifikasi: 0,
        laporan_sudah_diterima: 0,
        dalam_proses_penilaian: 0,
        laporan_perlu_diperbaiki: 0,
      },
      loadingLaporan: false,
      defaultStyle: {
        weight: 1,
        color: '#3388ff',
        fillColor: '#3388ff',
        fillOpacity: 0.4,
      },
    }
  },
  computed: {
    options() {
      return {
        onEachFeature: this.onEachFeatureFunction,
        style: this.defaultStyle,
      }
    },
    onEachFeatureFunction() {
      return (feature, layer) => {
        layer.on('click', () => {
          this.activeFeature = feature.properties
          this.getJumlahLaporanProvinsi()

          if (this.activeLayer) {
            this.activeLayer.setStyle(this.defaultStyle)
          }

          layer.setStyle({
            weight: 2,
            color: '#00aa00',
            fillColor: '#66ff66',
            fillOpacity: 0.7,
          })
          this.activeLayer = layer
        })

        layer.on('mouseover', () => {
          layer.setStyle({
            weight: 2,
            color: '#ffcc00',
            fillColor: '#ffe680',
            fillOpacity: 0.7,
          })
        })

        layer.on('mouseout', () => {
          if (this.activeFeature?.PROVINSI === feature.properties?.PROVINSI) return
          layer.setStyle(this.defaultStyle)
        })
      }
    },
  },
  methods: {
    onMapReady(map) {
      L.easyButton('fa-refresh', () => {
        this.activeLayer.setStyle(this.defaultStyle)
        this.activeFeature = null
      }).addTo(map)

      L.easyButton('fa-window-maximize', () => {
        map.setView(this.center, 5)
      }).addTo(map)
    },

    async getJumlahLaporanProvinsi() {
      const id_provinsi = this.activeFeature?.id
      if (!id_provinsi) return
      this.loadingLaporan = true
      const res = await axios.get(
        `${this.baseapiPengendalian}api/dashboard/getJumlahLaporanProvinsi?tahun=${this.tahun}&bulan=${this.bulan}&id_provinsi=${id_provinsi}`,
        this.getApiOption(),
      )
      if (res.data?.data) {
        const data = res.data.data
        this.dataLaporan = {
          jumlah_laporan_tahunan: data.laporan_tahunan || 0,
          laporan_tahunan_selesai: data.laporan_selesai || 0,
          laporan_belum_diverifikasi: data.laporan_belum_verifikasi || 0,
          laporan_sudah_diterima: data.laporan_sudah_terima || 0,
          dalam_proses_penilaian: data.laporan_dalam_proses || 0,
          laporan_perlu_diperbaiki: data.laporan_perlu_diperbaiki || 0,
        }
      }
      this.loadingLaporan = false
    },

    getApiOption(option = {}) {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
        ...option,
      }
    },
  },
  created() {
    this.geojson = provinsi
  },
  watch: {
    tahun() {
      if (this.activeFeature) this.getJumlahLaporanProvinsi()
    },
    bulan() {
      if (this.activeFeature) this.getJumlahLaporanProvinsi()
    },
  },
}
</script>

<style scoped>
.data-container {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #eeeeee;
  border: 1px solid #444444;
  padding: 10px;
  border-radius: 5px;
}
</style>
